import { render, staticRenderFns } from "./MoreMenuItemNSFWUserSetting.vue?vue&type=template&id=f83556b8&scoped=true&"
import script from "./MoreMenuItemNSFWUserSetting.vue?vue&type=script&lang=ts&"
export * from "./MoreMenuItemNSFWUserSetting.vue?vue&type=script&lang=ts&"
import style0 from "./MoreMenuItemNSFWUserSetting.vue?vue&type=style&index=0&id=f83556b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83556b8",
  null
  
)

export default component.exports